import { useMemo } from "react";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys";
import type { BoardContext } from "@/bryntum-lib/models/BoardContext";

export function useActiveBoardContext() {
  const { project, selectedBoard } = useSwivuBryntumContext();
  const boardId = selectedBoard?.record?.id;
  const { version: boardContextVersion } = useSwivuStore({ storeId: STORE_KEYS.boardContextStore });

  const activeContext = useMemo(() => {
    if (!project || boardId == null) return null;
    const store = project.getCrudStore(STORE_KEYS.boardContextStore);
    if (!store) return null;
    const records = store.records as unknown as BoardContext[];
    return (
      records.find((r) => (r.board === boardId || r.board === Number(boardId)) && r.isActive) ?? null
    );
  }, [project, boardId, boardContextVersion]);

  const contextLabel = activeContext?.name?.trim() || null;

  return { activeContext, contextLabel };
}
